var _circle, _path, _path2, _circle2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTier5Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "changeBg",
    cx: 10.4999,
    cy: 10.4999,
    r: 8.0458,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M12.1914 6.0625L13.0308 9.84412",
    stroke: "",
    strokeWidth: 0.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "changeStroke",
    d: "M8.31055 9.24023L7.91736 10.4995",
    stroke: "",
    strokeWidth: 0.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "changeStroke2",
    cx: 10.5,
    cy: 10.5,
    r: 10.2812,
    stroke: "#F1F1F1",
    strokeWidth: 0.4375
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3473 5.12118C10.3623 5.02341 10.5026 5.02177 10.5199 5.11915L11.5476 10.8956C11.5772 11.062 11.6386 11.2211 11.7286 11.3641L13.8396 14.7232C13.8904 14.804 13.7935 14.8962 13.7154 14.8415L11.1799 13.0673C10.7281 12.7512 10.1268 12.7512 9.67499 13.0673L7.16727 14.8221C7.08795 14.8776 6.99056 14.7822 7.04437 14.7018L9.25876 11.3897C9.36539 11.2302 9.43576 11.0493 9.46491 10.8596L10.3473 5.12118Z",
    fill: "url(#paint0_linear_899_2779)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "changeFill",
    d: "M10.3473 5.12118C10.3623 5.02341 10.5026 5.02177 10.5199 5.11915L11.5476 10.8956C11.5772 11.062 11.6386 11.2211 11.7286 11.3641L13.8396 14.7232C13.8904 14.804 13.7935 14.8962 13.7154 14.8415L11.1799 13.0673C10.7281 12.7512 10.1268 12.7512 9.67499 13.0673L7.16727 14.8221C7.08795 14.8776 6.99056 14.7822 7.04437 14.7018L9.25876 11.3897C9.36539 11.2302 9.43576 11.0493 9.46491 10.8596L10.3473 5.12118Z",
    fill: ""
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_2779",
    x1: 14.4131,
    y1: 19.15,
    x2: 6.96828,
    y2: 7.61773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2A2A2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTier5Icon);
export default __webpack_public_path__ + "static/media/tier-5-icon.871d3889dccff15e8d0123c1dce0cdda.svg";
export { ForwardRef as ReactComponent };